import { buttonReset } from 'components/Button/Button.styles'
import { styled } from 'stitches.config'

export const FeedingPillSelectorRoot = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
})

export const Eyebrow = styled('p', {
  fontFamily: '$primary',
  fontWeight: '$medium',
  fontSize: '$body',
  color: 'rgba(0, 0, 0, 0.7)',
  letterSpacing: '2.2px',
  textTransform: 'uppercase',
  textAlign: 'left',

  '@bp3': {
    textAlign: 'center',
  },
})

export const Headline = styled('h3', {
  fontFamily: '$display',
  fontWeight: 400,
  fontSize: '$h4',
  lineHeight: '36px',
  letterSpacing: '-0.8px',
  color: '$accent-black',
  textAlign: 'left',

  '@bp1_1': {
    fontSize: '$h3',
    lineHeight: '45px',
    letterSpacing: '-1px',
  },

  '@bp3': {
    textAlign: 'center',
    fontSize: '$h3',
  },
})

export const PillGrid = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '$2',
})

export const PillRow = styled('div', {
  display: 'flex',
  gap: '12px',
})

export const PillOption = styled('span', {
  position: 'relative',
  display: 'block',
  flex: '1 1 0',
})

export const PillInput = styled('input', {
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',

  '& + label': {
    ...buttonReset,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '$1',
    width: '100%',
    fontFamily: '$primary',
    fontWeight: '$medium',
    fontSize: '$small',
    color: '$accent-black',
    textAlign: 'center',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    borderRadius: '$pill',
    padding: '$1 $2',
    backgroundColor: 'transparent',
    transition: 'background-color 0.15s ease, border-color 0.15s ease',
  },

  '& + label:hover': {
    borderColor: 'rgba(0, 0, 0, 0.4)',
  },

  '&:focus-visible + label': {
    outline: '2px solid $secondary-400',
    outlineOffset: '2px',
  },

  '&:checked + label': {
    borderColor: '$accent-black',
    backgroundColor: '$accent-black',
    color: '$accent-white',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)',
  },
})
